import React from 'react'
import { useSelector } from 'react-redux'

export default function EduTrackPrivacyPolicy() {

    const webProperties = useSelector(state => state.landingReducer.webProperties)

    return (
        <>
            <nav className="navbar sticky-top navbar-expand-lg navbar-light" style={{ backgroundColor: 'white' }}>
                <button style={{ background: 'white' }} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
                    aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
                    <div className="navbar-brand">
                        <img className="agile-supportlogo" src="images/common/EduTrackLogo.png" width="110" alt="" />
                    </div>
                </div>
            </nav>

            <div className='container ppc dflex flex-col gap-6 fs-12'>
                <h1>Privacy Policy – EduTrack</h1>
                <h4>Effective Date: July 1, 2025</h4><br />
                <h4>EduTrack ("we", "our", or "us") is a product of Cadrac Labs Pvt. Ltd., a company registered in India. EduTrack is a school-focused educational app designed to help manage student homework, academic reports, and important announcements. We are committed to protecting the privacy of all users — including students, parents, and teachers — and ensuring transparency in how we handle personal data.</h4><br />

                <h2>1. Information We Collect</h2>
                <h4>To enable core functionalities, we collect the following types of data:</h4>
                <ul>
                    <li><h5><strong>Personal Information:</strong> Full name, email address, phone number, address, user role (Student, Parent, or Teacher), qualification details (from teachers).</h5></li>
                    <li><h5><strong>Academic & Communication Data:</strong> Homework submissions, academic reports, internal communications, and announcements posted by teachers or administrators.</h5></li>
                    <li><h5><strong>Uploaded Files:</strong> Images, documents, videos, and other files submitted for assignments or reports.</h5></li>
                    <li><h5><strong>Device & Usage Data:</strong> Device type, OS version, app usage patterns, and technical logs (for troubleshooting and performance improvement).</h5></li>
                </ul>
                <br /><br />

                <h2>2. How We Use the Information</h2>
                <h4>We use the collected information to:</h4>
                <ul>
                    <li><h5><strong>Facilitate student homework submissions and performance tracking.</strong></h5></li>
                    <li><h5><strong>Enable schools to share academic reports and announcements with students and parents.</strong></h5></li>
                    <li><h5><strong>Allow teachers to manage and review student activities.</strong></h5></li>
                    <li><h5><strong>Authenticate users and maintain role-based access.</strong></h5></li>
                    <li><h5><strong>Improve app functionality and support user experience.</strong></h5></li>
                </ul>
                <br /><br />

                <h2>3. Permissions We Request</h2>
                <h4>EduTrack requests the following permissions to deliver full functionality:</h4>
                <ul>
                    <li><h5><strong>Camera Access:</strong> For capturing homework images or assignments.</h5></li>
                    <li><h5><strong>Storage/Media Access:</strong> To upload and view documents, images, and videos.</h5></li>
                    <li><h5><strong>Internet Access:</strong> Required for syncing data with the server and receiving real-time announcements.</h5></li>
                </ul>
                <h4>We only use these permissions for educational purposes and never for unauthorized access or tracking.</h4>
                <br /><br />

                <h2>4. Data Sharing and Disclosure</h2>
                <h4>We do not sell or rent your data to third parties. Data may be shared:</h4>
                <ul>
                    <li><h5><strong>Within the app ecosystem:</strong> For example, teachers viewing student submissions.</h5></li>
                    <li><h5><strong>With school administrators:</strong> For academic management purposes.</h5></li>
                    <li><h5><strong>With service providers:</strong> Such as cloud hosting and analytics, under strict confidentiality agreements.</h5></li>
                    <li><h5><strong>When required by law:</strong> Or to protect the rights and safety of users.</h5></li>
                </ul>
                <br /><br />

                <h2>5. Data Security and Retention</h2>
                <h4>We employ industry-standard security measures, including encryption and restricted access, to safeguard your data. Data is retained only as long as necessary for educational and legal purposes.</h4>
                <br /><br />

                <h2>6. Children’s Privacy</h2>
                <h4>EduTrack is used in schools and may involve students under the age of 18. We require that students use the app under parental or school supervision. We do not knowingly collect data from minors without appropriate consent.</h4>
                <br /><br />

                <h2>7. User Rights and Choices</h2>
                <h4>Users have the right to:</h4>
                <ul>
                    <li><h5><strong>Access and update their personal information.</strong></h5></li>
                    <li><h5><strong>Request deletion of their data or account by contacting us at:</strong> support@wetasker.com</h5></li>
                    <li><h5><strong>Manage app permissions through their device settings.</strong></h5></li>
                </ul>
                <br /><br />

                <h2>8. Changes to This Policy</h2>
                <ul>
                    <li><h5>We may update this Privacy Policy from time to time. Significant changes will be communicated via in-app notices or emails.</h5></li>
                </ul>
                <br /><br />

                <h2>9. Contact Us</h2>
                <ul>
                    <li><h5>If you have any questions or concerns about your privacy or this policy, please contact:</h5></li>
                    <li><h5><strong>EduTrack Support Team:</strong> support@wetasker.com</h5></li>
                </ul>
            </div>

            <footer id="footer-releasenote" style={{ backgroundColor: webProperties?.PRIMARY_COLOR !== "#47974b" ? webProperties?.PRIMARY_COLOR : '#47974b' }}>
                <div style={{ color: 'white' }}>
                    EduTrack © Copyright {new Date().getFullYear()}. All Rights Reserved.
                </div>
            </footer>
        </>
    )
}
